import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable()
export class RedactorAnalyticsService extends AnalyticsBase {
  public namespace = 'Redactor';
  public requireViewContext = true;

  public fullscreenToggle() {
    this.track('FullscreenToggle');
  }

  public htmlToggle() {
    this.track('HTMLToggle');
  }

  public fileUpload(type: 'image' | 'other') {
    this.track('FileUpload', { type });
  }
}
